import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { UiRadioComponent } from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

interface UiRadioOption {
  value: string;
  label: string;
  description?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-radio-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiRadioComponent, AppExampleSectionComponent],
  templateUrl: './radio-doc.component.html',
  styleUrl: './radio-doc.component.scss',
})
export class RadioDocComponent {
  protected readonly fruit = signal('mango');
  protected readonly plan = signal('pro');
  protected readonly payment = signal('');
  protected readonly isInvalid = signal(false);

  protected readonly fruits: UiRadioOption[] = [
    { value: 'mango', label: 'Mango' },
    { value: 'naranja', label: 'Naranja' },
    { value: 'fresa', label: 'Fresa' },
    { value: 'uva', label: 'Uva' },
  ];

  protected readonly plans: UiRadioOption[] = [
    { value: 'basic', label: 'Básico', description: '$0 / mes — hasta 2 usuarios' },
    { value: 'pro', label: 'Pro', description: '$299 / mes — hasta 20 usuarios' },
    { value: 'enterprise', label: 'Enterprise', description: 'Precio a convenir — usuarios ilimitados' },
  ];

  protected readonly paymentMethods: UiRadioOption[] = [
    { value: 'card', label: 'Tarjeta de crédito / débito' },
    { value: 'transfer', label: 'Transferencia bancaria' },
    { value: 'cash', label: 'Pago en efectivo', disabled: true },
  ];

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }
}
